module.exports = "data:image/webp;base64,"